// Add your custom JS here.
import BurgerButton from './components/burger-button';
import MainMenu from './components/main-menu';
import Header from './components/header';
import ReadMoreToggler from './components/read-more-toggler';
import MasonryGallery from './components/masonry-gallery';
import PhotoSwipeTheme from './components/photoswipe';
import Grid from './components/grid-animations';
import GMap from '../../../nelios-base/src/js/components/google-maps';
import ScrollAnimation from './components/scroll-animation';

/**
 * Calls a supplied function once
 * document has loaded.
 *
 * @param  {CallableFunction} onLoaded
 * @return {void}
 */
const domLoaded = (onLoaded) => {
	if (document.readyState !== 'loading') {
		// Document is already ready, call the callback directly
		onLoaded();
	} else if (document.addEventListener) {
		// All modern browsers to register DOMContentLoaded
		document.addEventListener('DOMContentLoaded', onLoaded);
	} else {
		// Old IE browsers
		document.attachEvent('onreadystatechange', function () {
			if (document.readyState === 'complete') {
				onLoaded();
			}
		});
	}
};

const App = {
	init() {

		const burgerButton = new BurgerButton();
		const mainMenu = new MainMenu();
		const header = new Header();

		// Photoswipe
		Array.from(document.querySelectorAll('.pswp-gallery')).map(el => new PhotoSwipeTheme(el));

		// Read More Toggler
		Array.from(document.querySelectorAll('.read-more-toggle-link')).map(el => new ReadMoreToggler(el));

		// Masonry Gallery
		Array.from(document.querySelectorAll('.masonry-gallery')).map(el => new MasonryGallery(el));

		// Google Maps
		Array.from(document.querySelectorAll('.map')).map(el => new GMap(el));

		const rooms = document.querySelectorAll('.room-list-item');
		if (rooms.length > 0) {
			Array.from(rooms).forEach((room) => {
				room.addEventListener('mouseenter', () => room.classList.add('active'));
				room.addEventListener('mouseleave', () => room.classList.remove('active'));
			});
		}

		// Observer for fade-in-me effect
		let observerOptions = {
			// threshold: [0, 1]
		};

		const observerEffectFade = new IntersectionObserver((entries) => {
			entries.map((entry, index) => {
				if (entry.isIntersecting) {
					setTimeout(() => {
						entry.target.classList.add('is-in-view');
						observerEffectFade.unobserve(entry.target);
					}, 50 * index);
				}
			});
		}, observerOptions);
		document.querySelectorAll('.fade-in-me, .fade-over-me').forEach(observable => observerEffectFade.observe(observable));

		//grid Animation
		Array.from(document.querySelectorAll('.grid-3d-wrapper')).map(el => new Grid(el));

		// Scroll Animation
		Array.from(document.querySelectorAll('[data-scroll-animation]')).map(el => new ScrollAnimation(el));

		// add dropdown menu with phones
		const phoneDesktop = document.getElementById('phones');
		const menuPhones = document.getElementById('phones-menu');
		phoneDesktop.addEventListener('click', function(event) {
			event.stopPropagation();
			menuPhones.classList.toggle('hidden');
		});
		document.addEventListener('click', function(event) {
			if (!menuPhones.classList.contains('hidden') && !menuPhones.contains(event.target) && event.target !== phoneDesktop) {
				menuPhones.classList.add('hidden');
			}
		});
		// add dropdown menu with phones
	},
};

domLoaded(() => {
	App.init();
});
